// Web strings for the nav package: categories (shared/API.md §41.1), teams (§41.6, P017/P271),
// archived channels (§41.4). The switcher itself reuses the Apple keys `switcher.*`; the team sheet's
// title reuses `teams.title`. BOTH languages.
export const strings: { es: Record<string, string>; en: Record<string, string> } = {
  es: {
    'web.categories.moveTo': 'Mover a…',
    'web.categories.newCategory': 'Nueva categoría…',
    'web.categories.newTitle': 'Nueva categoría',
    'web.categories.renameTitle': 'Renombrar categoría',
    'web.categories.rename': 'Renombrar',
    'web.categories.delete': 'Eliminar',
    'web.categories.deleteTitle': '¿Eliminar «%@»?',
    'web.categories.deleteMessage': 'Sus conversaciones vuelven a Canales y Mensajes directos.',
    'web.categories.moveUp': 'Subir',
    'web.categories.moveDown': 'Bajar',
    'web.categories.name': 'Nombre',
    'web.categories.namePlaceholder': 'Nombre de la categoría',
    'web.categories.nameHint': 'Hasta %d caracteres.',
    'web.categories.create': 'Crear',
    'web.categories.save': 'Guardar',
    'web.categories.failed': 'No se pudo guardar el cambio de categorías.',
    'web.categories.menu': 'Opciones de la categoría',
    'web.teams.switch': 'Cambiar de equipo',
    'web.teams.members': 'Miembros del equipo',
    'web.teams.addPeople': 'Agregar personas',
    'web.teams.seeAll': 'Ver todos los equipos',
    'web.teams.leave': 'Salir del equipo',
    'web.teams.leaveTitle': '¿Salir de «%@»?',
    'web.teams.leaveMessage': 'Dejarás sus canales. Tus mensajes directos se quedan.',
    'web.teams.leaveFailed': 'No se pudo salir del equipo.',
    'web.teams.join': 'Unirse',
    'web.teams.joinFailed': 'No se pudo unir al equipo.',
    'web.teams.joinableEmpty': 'No hay otros equipos a los que puedas unirte.',
    'web.teams.loadFailed': 'No se pudo cargar la lista.',
    'web.teams.membersSearch': 'Buscar personas',
    'web.teams.membersCount': '%d miembros',
    'web.teams.membersCountOne': '1 miembro',
    'web.teams.noMatches': 'Nadie coincide con «%@».',
    'web.teams.addSearch': 'Buscar personas que no están en el equipo',
    'web.teams.add': 'Agregar',
    'web.teams.addCount': 'Agregar (%d)',
    'web.teams.addFailed': 'No se pudo agregar a las personas.',
    'web.teams.added': 'Se agregaron %d personas al equipo.',
    'web.teams.addedOne': 'Se agregó 1 persona al equipo.',
    'web.teams.addEmpty': 'Todas las personas ya están en el equipo.',
    'web.teams.current': 'Equipo actual',
    'web.teams.shortcut': 'Ctrl+Alt+%d',
    'web.teams.shortcutMac': '⌘%d',
    'web.archived.tab': 'Archivados',
    'web.archived.channelsTab': 'Canales',
    'web.archived.empty': 'No hay canales archivados.',
    'web.archived.unavailable': 'El servidor no permite ver canales archivados.',
    'web.archived.restore': 'Restaurar canal',
    'web.archived.restoreConfirm': 'Restaurar',
    'web.archived.restoreFailed': 'No se pudo restaurar el canal.',
    'web.archived.restored': 'Canal restaurado.',
    'web.archived.label': 'Archivado',
  },
  en: {
    'web.categories.moveTo': 'Move to…',
    'web.categories.newCategory': 'New category…',
    'web.categories.newTitle': 'New category',
    'web.categories.renameTitle': 'Rename category',
    'web.categories.rename': 'Rename',
    'web.categories.delete': 'Delete',
    'web.categories.deleteTitle': 'Delete “%@”?',
    'web.categories.deleteMessage': 'Its conversations go back to Channels and Direct messages.',
    'web.categories.moveUp': 'Move up',
    'web.categories.moveDown': 'Move down',
    'web.categories.name': 'Name',
    'web.categories.namePlaceholder': 'Category name',
    'web.categories.nameHint': 'Up to %d characters.',
    'web.categories.create': 'Create',
    'web.categories.save': 'Save',
    'web.categories.failed': 'Could not save the category change.',
    'web.categories.menu': 'Category options',
    'web.teams.switch': 'Switch team',
    'web.teams.members': 'Team members',
    'web.teams.addPeople': 'Add people',
    'web.teams.seeAll': 'See all teams',
    'web.teams.leave': 'Leave team',
    'web.teams.leaveTitle': 'Leave “%@”?',
    'web.teams.leaveMessage': 'You will leave its channels. Your direct messages stay.',
    'web.teams.leaveFailed': 'Could not leave the team.',
    'web.teams.join': 'Join',
    'web.teams.joinFailed': 'Could not join the team.',
    'web.teams.joinableEmpty': 'There are no other teams you can join.',
    'web.teams.loadFailed': 'Could not load the list.',
    'web.teams.membersSearch': 'Search people',
    'web.teams.membersCount': '%d members',
    'web.teams.membersCountOne': '1 member',
    'web.teams.noMatches': 'Nobody matches “%@”.',
    'web.teams.addSearch': 'Search people who are not in the team',
    'web.teams.add': 'Add',
    'web.teams.addCount': 'Add (%d)',
    'web.teams.addFailed': 'Could not add the people.',
    'web.teams.added': '%d people were added to the team.',
    'web.teams.addedOne': '1 person was added to the team.',
    'web.teams.addEmpty': 'Everyone is already in the team.',
    'web.teams.current': 'Current team',
    'web.teams.shortcut': 'Ctrl+Alt+%d',
    'web.teams.shortcutMac': '⌘%d',
    'web.archived.tab': 'Archived',
    'web.archived.channelsTab': 'Channels',
    'web.archived.empty': 'There are no archived channels.',
    'web.archived.unavailable': 'The server does not allow viewing archived channels.',
    'web.archived.restore': 'Restore channel',
    'web.archived.restoreConfirm': 'Restore',
    'web.archived.restoreFailed': 'Could not restore the channel.',
    'web.archived.restored': 'Channel restored.',
    'web.archived.label': 'Archived',
  },
};
